import { useCallback } from 'react';
import { ISignal, useCustomFetch } from "../custom-fetch";
import IStation from "../shared/IStation";

export const useStationsService = () => {
  const customFetch = useCustomFetch();

  const fetchStations = useCallback(async ({ signal }: ISignal) => {
    const [stations] = await customFetch<IStation[]>("/json/stations", { signal });
    return stations;
  }, [customFetch]);

  const refreshStations = useCallback(async () => {
    const [stations] = await customFetch<IStation[]>("/json/stations/refresh", {
      method: "POST",
    });
    return stations;
  }, [customFetch]);

  return { fetchStations, refreshStations };
}
